import { useAppSelector } from 'application/providers/StoreProvider';
import { selectCompanyIds } from 'application/store/slices/accountSlice/selectors';

export const useAccountCompanyIds = () => {
  const companyIds = useAppSelector(selectCompanyIds);

  return companyIds;
};
